import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MonitorService } from '../../../../services/monitor.service';

export interface TransactionAlertNotesDialogData {
    alertId: string;
    notes?: {
        value: string;
        userName: string;
        userId: string;
        date: Date;
    };
    mode: 'view' | 'edit';
    alertType?: string;
    countryCode?: string;
    profileType?: string;
}

@Component({
    selector: 'bo-transaction-alert-notes-dialog',
    templateUrl: './transaction-alert-notes-dialog.component.html',
    styleUrls: ['./transaction-alert-notes-dialog.component.scss']
})
export class TransactionAlertNotesDialogComponent implements OnInit {
    notesForm: FormGroup;
    isLoading: boolean = false;
    isEditMode: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<TransactionAlertNotesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TransactionAlertNotesDialogData,
        private fb: FormBuilder,
        private monitorService: MonitorService,
        private toastr: ToastrService
    ) {
        this.isEditMode = data.mode === 'edit';
        this.notesForm = this.fb.group({
            notes: [
                { value: data.notes?.value || '', disabled: !this.isEditMode },
                Validators.maxLength(1000)
            ]
        });
    }

    ngOnInit(): void {}

    get dialogTitle(): string {
        return this.isEditMode ? 'Edit Notes' : 'View Notes';
    }

    get notesMetadata(): string {
        if (!this.data.notes || !this.data.notes.userName) {
            return '';
        }
        const date = new Date(this.data.notes.date);
        const formattedDate = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
        return `Last updated by ${this.data.notes.userName} on ${formattedDate}`;
    }

    saveNotes(): void {
        if (this.notesForm.invalid) {
            return;
        }

        this.isLoading = true;
        const notesValue = this.notesForm.get('notes')?.value || '';

        this.monitorService.saveTransactionAlertNotes(this.data.alertId, notesValue, this.data.alertType, this.data.countryCode, this.data.profileType).subscribe({
            next: (response) => {
                if (response.result === 'Success') {
                    this.toastr.success('Notes saved successfully');
                    this.dialogRef.close({ saved: true, notes: response.payload.notes });
                } else {
                    this.toastr.error(response.message || 'Failed to save notes');
                }
                this.isLoading = false;
            },
            error: (error) => {
                console.error('Failed to save notes:', error);
                this.toastr.error(error.error?.message || 'Failed to save notes');
                this.isLoading = false;
            }
        });
    }

    cancel(): void {
        this.dialogRef.close({ saved: false });
    }
}
